module.exports = __webpack_public_path__ + "img/icon_traslado_hover.9e9cd148.svg";